import * as React from 'react';

import cn from 'classnames';

import { ExperimentMoodPhotosVariant } from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { IImageProperties } from '@helpers/utils';

import {
  MainImg,
  BufferImage,
  fullHeightMainImgClass,
  notFullHeightMainImgClass,
} from './styled';
import { getImageProps, hasImageShadow, ImageProps } from './utils';

interface IMainImageProps {
  imageAttrs: IImageProperties;
  onClick: React.MouseEventHandler<HTMLImageElement>;
  index: number;
}

export const MainImage: React.FC<IMainImageProps> = (props) => {
  const { imageAttrs, onClick, index } = props;

  const { experiment_pd_mood_photos_variant } = useFeatureFlags();

  const [imgProps, setImageProps] = React.useState<
    ImageProps & IMainImageProps['imageAttrs']
  >(() => ({
    hasShadow: hasImageShadow(imageAttrs.src),
    fullHeight: false,
    ...props.imageAttrs,
  }));

  const handleImageLoad: React.ReactEventHandler<HTMLImageElement> = (
    event
  ) => {
    setImageProps({
      ...getImageProps(event.currentTarget, index),

      ...(experiment_pd_mood_photos_variant !==
        ExperimentMoodPhotosVariant.Default && {
        fullHeight:
          experiment_pd_mood_photos_variant ===
          ExperimentMoodPhotosVariant.AllMoodExceptFirst
            ? index > 0
            : true,
      }),

      ...props.imageAttrs,
    });
  };

  return (
    <>
      <MainImg
        {...imgProps}
        alt={imageAttrs.alt}
        onClick={onClick}
        loading="eager"
        id="pd-image-main"
        className={cn({
          [fullHeightMainImgClass]: imgProps.fullHeight,
          [notFullHeightMainImgClass]: !imgProps.fullHeight,
        })}
      />

      {/* Preload image and calculate its size before we render it so there is no flickering*/}
      <BufferImage
        loading="eager"
        {...imageAttrs}
        alt=""
        onLoad={handleImageLoad}
      />
    </>
  );
};
